module.exports = {"130481100":"武安镇","130481101":"康二城镇","130481102":"午汲镇","130481103":"磁山镇","130481104":"伯延镇","130481105":"淑村镇","130481106":"大同镇","130481107":"邑城镇","130481108":"矿山镇","130481109":"贺进镇","130481110":"阳邑镇","130481111":"徘徊镇","130481112":"冶陶镇","130481200":"上团城乡","130481201":"北安庄乡","130481202":"北安乐乡","130481203":"西土山乡","130481204":"西寺庄乡","130481205":"活水乡","130481206":"石洞乡","130481207":"管陶乡","130481208":"马家庄乡"}


//////////////////
// WEBPACK FOOTER
// ./src/town/130481.json
// module id = 117
// module chunks = 0